
import {  isSet } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningBoxLifting = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    // Final Results options: Normal | Abnormal | Positive | Negative | Pass | Fail
    const finalResultsOptions = [
        { label: 'Not Started', value: 'Not Started' },
        // { label: 'Normal', value: 'Normal' },
        // { label: 'Abnormal', value: 'Abnormal' },
        // { label: 'Positive', value: 'Positive' },
        // { label: 'Negative', value: 'Negative' },
        { label: 'Passed', value: 'Passed' },
        { label: 'Failed', value: 'Failed' }
    ];
    // Activity Status options: Not Started | Ordered | Completed | Cancelled
    const activityStatusOptions = [
        { label: 'Not Started', value: 'Not Started' },
        { label: 'Pending Provider Review', value: 'Pending Provider Review' },
        { label: 'Ordered', value: 'Ordered' },
        { label: 'Passed', value: 'Passed' },
        { label: 'Failed', value: 'Failed' }
        // { label: 'Completed', value: 'Completed' },
        // { label: 'Cancelled', value: 'Cancelled' }
    ];
    
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'activity_details',
                label:'Activity Details',
                data:[
                    {
                        label:'Activity Details - '+props.activityName,
                        labelStyle: "fw-semibold",
                        fields:[{
                            label:'Weighted Lift and Review of proper Body Mechanics with the  following:',
                            col:'col-12',
                            type:'CheckBoxGroup',
                            name:'weightList',
                            id:'weightList',
                            options:[{label:' Floor to waist x 3',name:'floor_to_waist'},{label:' Push / Pull x 3',name:'push_pull'},{label:' Waist level carry with pivot',name:'waist_level_carry'},{label:'Waist to shoulder x 3',name:'waist_to_shoulder'}],
                        }
                    ]
                    },{
                        label:'Employee has demonstrated properly lifting technique with weight requirements',
                        labelStyle: "fw-semibold",
                        fields:[{
                            label:'Recommendations',
                            col:'col-12',
                            type:'RadioGroup',
                            name:'recommendations',
                            id:'recommendations',
                            options:['No Restrictions','Restrictions'],
                        },
                       
                        {
                            label:'Notes',
                            col:'col-12',
                            type:'TextArea',
                            name:'notes',
                        },
                        // {
                        //     label:'Status',
                        //     col:'col-6',
                        //     type:'SelectList',
                        //     options:isSet(props.lookupsOptions['chartResult'],[]),
                        //     name:'status',
                        // }
                    ]
                    },
                    {
                        label: "Review / Completion",
                        labelStyle: "fw-semibold",
                        fields: [
                            {
                                type: "ProviderSignOff",
                                col: "col-12",
                                fields: [
                                    { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                                    { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                                    { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                                    // { label : "Suggested Result",disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                                    // Previous options:
                                    // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: finalResultsOptions,statusBasedColor: true },
                                    // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: activityStatusOptions,statusBasedColor: true },
                                    // New standard options:
                                    { 
                                        label : "Final Results",
                                        type: "SelectList",
                                        name: "status",
                                        col: "col-12",
                                        options: [
                                            { label: 'Not Started', value: 'Not Started' },
                                            { label: 'Pending', value: 'Pending' },
                                            { label: 'Normal', value: 'Normal' },
                                            { label: 'Abnormal', value: 'Abnormal' },
                                            { label: 'Negative', value: 'Negative' },
                                            { label: 'Positive', value: 'Positive' },
                                            { label: 'Dispensed', value: 'Dispensed' },
                                            { label: 'Administered', value: 'Administered' },
                                            { label: 'Failed', value: 'Failed' },
                                            { label: 'Passed', value: 'Passed' },
                                            { label: 'Non-Negative', value: 'Non-Negative' },
                                            { label: 'Cancelled', value: 'Cancelled' },
                                            { label: 'Inconclusive', value: 'Inconclusive' },
                                        ],
                                        statusBasedColor: true
                                    },
                                    { 
                                        label : "Activity Status",
                                        type: "SelectList",
                                        name: "activity_status",
                                        col: "col-12",
                                        options: [
                                            { label: 'Not Started', value: 'Not Started' },
                                            { label: 'Pending', value: 'Pending' },
                                            { label: 'Pending Lab Confirmation', value: 'Pending Lab Confirmation' },
                                            { label: 'Pending MRO Confirmation', value: 'Pending MRO Confirmation' },
                                            { label: 'Ready for Review', value: 'Ready for Review' },
                                            { label: 'Completed', value: 'Completed' },
                                            { label: 'Cancelled', value: 'Cancelled' },
                                        ],
                                        statusBasedColor: true
                                    },
                                ],
                            },
                        ],
                    }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        // suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Activity Details',
                id: 'activity_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => computationRules(formData,key)};
}

const computationRules = (formData,key)=>{
    let returnResult = {};
    const currentStatus = isSet(formData.status, "Not Started");
    const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  
    // If user changes any field while both status and activity_status are "Not Started",
    // move to Pending Result / In Progress
    if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
      returnResult.status = "Pending";
      returnResult.activity_status = "Pending";
    }
    if(key==='recommendations' || formData.recommendations){
            returnResult.activity_status = 'Completed';
    }else if(key==='recommendations' || !formData.recommendations){
            returnResult.activity_status = 'Pending';
    }
    // if(key === 'status' && formData.status) {
    //   const status = formData.status;
    //   // Check if provider has signed (provider_signature exists and is not empty)
    //   const providerSigned = formData.provider_signature && 
    //                         formData.provider_signature !== "" && 
    //                         formData.provider_signature !== null && 
    //                         formData.provider_signature !== undefined;
      
    //   switch(status) {
    //       case 'Not Started':
    //           returnResult.activity_status = 'Not Started';
    //           break;
    //       case 'Pending':
    //           returnResult.activity_status = 'Pending';
    //           break;
    //       case 'Normal':
    //           // If provider signed, set to Completed; otherwise Pending
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Abnormal':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Negative':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Positive':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Dispensed':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Administered':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Failed':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Passed':
    //           returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //           break;
    //       case 'Non-Negative':
    //           returnResult.activity_status = 'Pending Lab Confirmation';
    //           break;
    //       case 'Cancelled':
    //           returnResult.activity_status = 'Cancelled';
    //           break;
    //       case 'Inconclusive':
    //           returnResult.activity_status = 'Pending Lab Confirmation';
    //           break;
    //       default:
    //           // No change if status doesn't match any case
    //           break;
    //   }
    // }
    
    // Also check when provider_signature changes - if status is a completion status, update activity_status
    // if(key === 'provider_signature' && formData.status) {
    //   const status = formData.status;
    //   const providerSigned = formData.provider_signature && 
    //                         formData.provider_signature !== "" && 
    //                         formData.provider_signature !== null && 
    //                         formData.provider_signature !== undefined;
      
    //   // Completion statuses that should become "Completed" when provider signs
    //   const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
      
    //   if (completionStatuses.includes(status)) {
    //     returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    //   }
    // }
    return returnResult;
}
// Commented out existing computation rules - now using shared computationRules1 from DrugScreenCollection.js
/*
const computationRules = (formData,key)=>{
  if(key==='status' && formData.status==='Not Started' ){
    return {
      status: 'Not Started',
      activity_status: 'Not Started'
    };
  }
  if((key==='status' || key==='provider_signature') && formData.status==='Passed' && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined) ){
    return {
      activity_status: 'Passed'
    };
  }
  if((key==='status' || key==='provider_signature') && formData.status==='Failed' && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined) ){
    return {
      activity_status: 'Failed'
    };
  }
  if((key==='status' || key==='provider_signature') && formData.status==='failed' && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined) ){
    return {
      activity_status: 'Pending Provider Review'
    };
  }
  if((key==='status' || key==='provider_signature') && formData.status==='Passed' && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined) ){
    return {
      activity_status: 'Pending Provider Review'
    };
  }
  return {};
}
*/